import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const ActivityIndicator = props => {
    const { color = null } = props;

    return (
        <CircularProgress
            color={color ? color : "primary"}
        />
    )
};

export default ActivityIndicator;
